import i18n from '@/i18n';

/**
 * Abbreviate a token count. Token counts run into the millions, where the exact
 * digits are noise; the precise value belongs in a tooltip.
 */
export const toPrettyTokens = (tokens) => {
  const value = Number(tokens || 0);
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(2)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}k`;
  }
  return String(value);
};

export const toGroupedNumber = (value) => Number(value || 0).toLocaleString(i18n.global.locale.value || 'nl-NL');
